import { render, staticRenderFns } from "./GiveawayList.vue?vue&type=template&id=20152421&lang=pug&"
import script from "./GiveawayList.vue?vue&type=script&lang=js&"
export * from "./GiveawayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports